"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RoadmapsController = /** @class */ (function () {
    function RoadmapsController($window, $state, RoadmapsModel, FlashService) {
        var _this = this;
        this.$window = $window;
        this.$state = $state;
        this.RoadmapsModel = RoadmapsModel;
        this.FlashService = FlashService;
        this.roadmaps = [];
        this.pagination = { current_page: 1, last_page: 1, total: 0 };
        this.loading = false;
        this.error = "";
        this.page_by = 10;
        this.onPageChange = this.fetch.bind(this);
        this.onCreate = function () { return _this.$state.go("drivecoach.admin.roadmaps.create"); };
        this.onEdit = function (roadmap) {
            return _this.$state.go("drivecoach.admin.roadmaps.edit", {
                roadmapID: roadmap.id,
            });
        };
        this.onDelete = this.removeRoadmap.bind(this);
        this.fetch(1);
    }
    RoadmapsController.prototype.fetch = function (page) {
        var _this = this;
        this.loading = true;
        this.error = "";
        this.RoadmapsModel.get({ page: page, page_by: this.page_by })
            .then(function (response) {
            _this.roadmaps = response.roadmaps.data;
            _this.pagination = {
                current_page: response.roadmaps.current_page,
                last_page: response.roadmaps.last_page,
                total: response.roadmaps.total,
            };
            _this.loading = false;
        })
            .catch(function () {
            _this.error = "Failed to load roadmaps.";
            _this.loading = false;
        });
    };
    RoadmapsController.prototype.removeRoadmap = function (roadmap) {
        var _this = this;
        var confirm = this.$window.confirm("Are you sure you want to delete this roadmap? Students keep the lessons already assigned to them.");
        if (confirm === false) {
            return;
        }
        this.RoadmapsModel.delete(roadmap)
            .then(function (response) {
            _this.FlashService.setMessage({
                message: response.message,
                type: "success",
            });
            _this.fetch(_this.pagination.current_page);
        })
            .catch(function () {
            _this.error = "Failed to delete the roadmap.";
        });
    };
    return RoadmapsController;
}());
RoadmapsController.$inject = [
    "$window",
    "$state",
    "RoadmapsModel",
    "FlashService",
];
exports.default = RoadmapsController;
